module.exports = __webpack_public_path__ + "static/media/J6.04c3d0cf.jpg";